import React from 'react';

import { ListItem, ListItemText, Button } from '@mui/material';

import type { Column } from 'api/shared/models';

import { styles } from '../styles';

interface Props {
  column: Column;
  onClick: (column: Column) => void;
}

const Option = ({ column, onClick }: Props) => {
  return (
    <ListItem disablePadding sx={styles.listItem}>
      <Button
        onClick={() => onClick(column)}
        disableTouchRipple
        variant="outlined"
        sx={styles.listItemButton}
      >
        <ListItemText primary={column.label} />
      </Button>
    </ListItem>
  );
};

export default Option;
